import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./cloud/AuthProvider";
import { bootDb } from "./db/boot";
// Fonte Hanken Grotesk self-hostada (Modelo A) — empacotada via @fontsource, então
// funciona OFFLINE no WebView nativo (Capacitor), sem depender do Google Fonts.
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/600.css";
import "@fontsource/hanken-grotesk/700.css";
import "./ui/theme.css";
import "./ui/ui.css";

async function start() {
  try {
    await bootDb();
  } catch (e) {
    // Local-first: se o IndexedDB falhar, ainda renderiza (a UI mostra vazio).
    console.error("Falha ao iniciar o banco local:", e);
  }
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>,
  );
}

void start();
